// MUI v6 — дефолты компонентов в стиле Material Design 3.
// Button (filled, rounded), Card (elevation 1), Chip (outlined), TextField (outlined),
// Dialog (maxWidth=sm), AppBar (sticky, surface).
import type { Components, Theme } from '@mui/material/styles';

/** Кастомизация MUI компонентов под MD3. */
export const md3Components: Components<Omit<Theme, 'components'>> = {
  MuiButton: {
    defaultProps: { variant: 'contained', disableElevation: false },
    styleOverrides: {
      root: { borderRadius: 20, textTransform: 'none', fontWeight: 500 },
    },
  },
  MuiCard: {
    defaultProps: { variant: 'elevation', elevation: 1 },
  },
  MuiChip: {
    defaultProps: { variant: 'outlined', size: 'small' },
    styleOverrides: {
      root: { borderRadius: 8 },
    },
  },
  MuiTextField: {
    defaultProps: { variant: 'outlined', size: 'medium', fullWidth: true },
  },
  MuiDialog: {
    defaultProps: { maxWidth: 'sm', fullWidth: true },
  },
  MuiAppBar: {
    defaultProps: { position: 'sticky', color: 'default' },
  },
  MuiIconButton: {
    styleOverrides: {
      root: { borderRadius: 20 },
    },
  },
  MuiPaper: {
    defaultProps: { elevation: 1 },
  },
  // U-33 (sled-V11): адаптация UA-автозаполнения Chrome к теме (Adapter).
  // Chrome красит autofill-поля синим (#e8f0fe) и чёрным текстом поверх MUI-темы;
  // inset-shadow прозрачный + долгая transition фона — UA-фон «уезжает» в цвет темы,
  // text-fill-color: inherit — текст по теме (работает и в dark).
  MuiCssBaseline: {
    styleOverrides: {
      'input:-webkit-autofill, input:-webkit-autofill:hover, input:-webkit-autofill:focus, input:-webkit-autofill:active': {
        WebkitBoxShadow: '0 0 0 1000px transparent inset',
        WebkitTextFillColor: 'inherit',
        caretColor: 'inherit',
        transition: 'background-color 5000s ease-in-out 0s',
      },
      // Label MUI не всегда «поднимается» при autofill (события input не всегда
      // приходят в React) — принудительно прячем label в shrink-позицию для outlined.
      '.MuiOutlinedInput-root:has(input:-webkit-autofill) .MuiInputLabel-outlined': {
        transform: 'translate(14px, -9px) scale(0.75)',
      },
    },
  },
};
